import { cn } from '@/lib/utils';
import type React from 'react';

export const textInputStyle = cn(
  // white bg
  'tw:bg-white',
  // basic
  'tw:h-8 tw:w-full tw:min-w-0 tw:px-2.5 tw:py-1 tw:text-base tw:md:text-sm ',
  // border
  'tw:rounded-lg tw:border tw:border-input tw:transition-colors tw:outline-none ',
  // tw:file:
  'tw:file:inline-flex tw:file:h-6 tw:file:border-0 tw:file:bg-transparent tw:file:text-sm tw:file:font-medium tw:file:text-foreground ',
  // tw:focus-visible:
  'tw:focus-visible:border-ring tw:focus-visible:ring-3 tw:focus-visible:ring-ring/50 ',
  // tw:disabled:
  'tw:disabled:pointer-events-none tw:disabled:cursor-not-allowed tw:disabled:bg-input/50 tw:disabled:opacity-50 ',
  // tw:aria-invalid:
  'tw:aria-invalid:border-destructive tw:aria-invalid:ring-3 tw:aria-invalid:ring-destructive/20 ',
  // tw:placeholder:
  'tw:placeholder:text-muted-foreground ',
  // dark mode
  'tw:dark:bg-input/30 tw:dark:disabled:bg-input/80 tw:dark:aria-invalid:border-destructive/50 tw:dark:aria-invalid:ring-destructive/40 ',
);

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot='input'
      className={cn(textInputStyle, className)}
      {...props}
    />
  );
}

export { Input };
